'use client';

import { Area, AreaChart, CartesianGrid, XAxis } from 'recharts';

import { Card, CardContent } from '@/components/ui/card';
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent
} from '@/components/ui/chart';

const chartData = [
  { month: 'January', desktop: 186, mobile: 80 },
  { month: 'February', desktop: 305, mobile: 200 },
  { month: 'March', desktop: 237, mobile: 120 },
  { month: 'April', desktop: 73, mobile: 190 },
  { month: 'May', desktop: 209, mobile: 130 },
  { month: 'June', desktop: 214, mobile: 140 }
];

const chartConfig = {
  desktop: {
    label: 'Desktop',
    color: '#EB2F96'
  },
  mobile: {
    label: 'Mobile',
    color: '#1269FF'
  }
} satisfies ChartConfig;

export function ChartAreaLegend() {
  return (
    <Card>
      <CardContent>
        <ChartContainer config={chartConfig}>
          <AreaChart
            accessibilityLayer
            data={chartData}
            margin={{
              left: 12,
              right: 12
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="month"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={value => value.slice(0, 3)}
            />
            <ChartTooltip cursor={false} content={<ChartTooltipContent indicator="line" />} />
            <Area
              type="natural" // 曲线类型，natural 为自然曲线
              dataKey="desktop" // 对应数据中的 mobile 字段
              fill="#1269FF" // 填充色（蓝色）
              fillOpacity={0.1} // 填充透明度
              stroke="#1269FF" // 描边色（深蓝色）
              strokeWidth={2} // 描边宽度
            />
            {/* 下部分面积：粉色填充、粉色描边 */}
            <Area
              type="natural"
              dataKey="mobile" // 对应数据中的 desktop 字段
              fill="#EB2F96" // 填充色（粉色）
              fillOpacity={0.1} // 填充透明度
              stroke="#EB2F96" // 描边色（深粉色）
              strokeWidth={2} // 描边宽度
            />
            <ChartLegend content={<ChartLegendContent />} />
          </AreaChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
